export const APP_NAME = "ВсеСкан";
export const APP_TAGLINE = "для проведения диагностики стоп";
export const APP_TITLE = `${APP_NAME} - ${APP_TAGLINE}`;
